import { Box, Typography } from "@mui/material";

import { csvLineNotes } from "./csvReviewFormat";

const CsvLineNotes = ({ line, closedYears }) => (
  <Box sx={{ display: "flex", flexDirection: "column", maxWidth: 260 }}>
    {csvLineNotes(line, closedYears).map((note) => (
      <Typography key={note} variant="caption" color="textSecondary">
        {note}
      </Typography>
    ))}
  </Box>
);

export default CsvLineNotes;
